import React, { ReactNode } from "react";
import BaseChart from "../baseChart/BaseChart";
import { ResponsiveSwarmPlot } from '@nivo/swarmplot'
import { Container } from "./Styled";

type SwarmPlotProps = {
    data?: any;
    title: string;
    groups: string[];
    durationRange: number[];
    tooltip?: (node: ReactNode) => void;
    showDrawer?: (event: any) => void;
};

const SwarmPlot: React.FunctionComponent<SwarmPlotProps> = ({
    data,
    title,
    durationRange,
    groups,
    tooltip,
    showDrawer
}) => {

    return (
        <Container>
            <BaseChart title={title}>
                <ResponsiveSwarmPlot
                    data={data}
                    groups={groups}
                    identity="id"
                    value="duration"
                    valueScale={{ type: 'linear', min: durationRange[0], max: durationRange[1], reverse: false, }}
                    size={{ key: 'volume', values: [4, 20], sizes: [6, 20] }}
                    forceStrength={4}
                    simulationIterations={120}
                    borderColor={{
                        from: 'color',
                        modifiers: [
                            [
                                'darker',
                                0.6
                            ],
                            [
                                'opacity',
                                0.5
                            ]
                        ]
                    }}
                    useMesh={true}
                    tooltip={tooltip}
                    margin={{ top: 20, right: 50, bottom: 60, left: 50 }}
                    axisBottom={null}
                    axisLeft={{
                        tickSize: 10,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: 'groups',
                        legendPosition: 'middle',
                        legendOffset: -76,
                    }}
                    onClick={(event) => { if (showDrawer) showDrawer(event) }}
                />
            </BaseChart>
        </Container >
    )
}

export default SwarmPlot